import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import React from "react";

export const settingsMenus = [
  {
    label: "sidebar.menu.account",
    type: "section",
    children: [
      {
        uri: "/profile",
        label: "sidebar.menuItem.profile",
        type: "nav-item",
        icon: <PersonOutlineIcon sx={{fontSize: 20}} />,
      },
    ],
  },
];
